import { createSelector } from "@reduxjs/toolkit";
var selectToast = function (state) { return state.toast; };
export var selectToasts = createSelector(selectToast, function (toast) { return toast.toasts; });
